import {
    AccountConnections,
    AccountDetails,
    AccountEvents,
    AccountLayout,
    AccountOverview,
    AccountSecurity,
    AccountSettings,
} from '@account/routes';
import { NotFound } from '@routes/NotFound';
import { Navigate, Route, Routes } from 'react-router-dom';

export const AccountRoutes = () => {
    return (
        <Routes>
            <Route index element={<Navigate to="details" replace />} />
            <Route path="details" element={<AccountLayout />}>
                <Route index element={<AccountOverview />} />
                <Route path="edit" element={<AccountDetails />} />
                <Route path="my-events" element={<AccountEvents />} />
                <Route path="security" element={<AccountSecurity />} />
                <Route path="connections" element={<AccountConnections />} />
                <Route path="settings" element={<AccountSettings />} />
            </Route>
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};
